import { HYDRATE } from 'next-redux-wrapper';

import {
    SET_BANNER_FOR_INTERNET,
    SET_TARIFFS_FOR_INTERNET,
    SET_TARIFFS_FOR_INTERNET_SELF_ORDER,
} from '../actionTypes/internet';

const initialState = {
    tariffs: [],
    tariffsSelfOrder: [],
    banner: {
        image_background: '',
        image: '',
        text: '',
        title: '',
        button_text: '',
        link: '',
    },
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {
        case HYDRATE:
            return { ...state, ...action.payload.internet };

        case SET_BANNER_FOR_INTERNET:
            return ({
                ...state,
                banner: { ...payload },
            });

        case SET_TARIFFS_FOR_INTERNET:
            return ({
                ...state,
                tariffs: [...payload],
            });

        case SET_TARIFFS_FOR_INTERNET_SELF_ORDER:
            return ({
                ...state,
                tariffsSelfOrder: [...payload],
            });

        default:
            return state;
    }
};
